import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonLoading, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import { arrowBack, ticketOutline } from 'ionicons/icons';
import React, { useState } from 'react';
import "./Cupom.css";


type Props = {
  configuracoesCupom: any[];
  cupom: any;
  closeAction: Function;
  closeActionSimple: Function;
};

const Cupom: React.FC<Props> = (props: Props) => {

  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [cupomManual, setCupomManual] = useState<string>("");

  const aplicarCupomManual = () => {
    const digitado = (cupomManual || "").trim();
    if (!digitado) {
      setTextToast("Digite o código do cupom.");
      setShowToast(true);
      return;
    }
    // Procura na lista completa (inclui cupons invisíveis) para permitir
    // que o cliente use cupons ocultos digitando manualmente.
    const alvo = digitado.toLowerCase();
    const encontrado = Array.isArray(props.configuracoesCupom)
      ? props.configuracoesCupom.find((c: any) => (c?.nome || '').toString().trim().toLowerCase() === alvo)
      : null;
    if (!encontrado) {
      setTextToast("Cupom não disponível.");
      setShowToast(true);
      return;
    }
    props.closeAction(encontrado.valor, encontrado.nome);
  };

  const loadConfiguracoesCupom = () => {

    // Cupons invisíveis (visivel === false) não devem ser listados, mas continuam
    // válidos via digitação manual no campo acima.
    const cuponsVisiveis = Array.isArray(props.configuracoesCupom)
      ? props.configuracoesCupom.filter((c: any) => c?.visivel !== false)
      : [];

    if (cuponsVisiveis.length === 0) {
      return (
        <div className="Cupom-empty" key="cupom-vazio">
          <IonIcon icon={ticketOutline} />
          <h2>Nenhum cupom disponível</h2>
          <p>Se você tem um código de cupom, digite-o no campo acima.</p>
        </div>
      );
    }

    return (
      <>
        <div className="Cupom-section-title">Cupons disponíveis</div>
        {cuponsVisiveis.map((value: any, index: any) => (
          <div
            key={"cupom" + (value.id || value.nome || index)}
            className="Cupom-card"
            onClick={() => props.closeAction(value.valor, value.nome)}
          >
            <div className="Cupom-card-icon">
              <IonIcon icon={ticketOutline} />
            </div>
            <div className="Cupom-card-info">
              <span className="Cupom-card-nome">
                Cupom <strong>{value.nome}</strong>
              </span>
              <span className="Cupom-card-valor">R$ {value.valor} de desconto</span>
              <span className="Cupom-card-minimo">
                Válido para pedidos acima de R$ {value.valorMinimo}
              </span>
            </div>
          </div>
        ))}
      </>
    );
  }

  return (

    <>
      <IonHeader className="ion-no-border">
        <IonToolbar>

          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => {
              props.closeActionSimple();
            }} />
          </IonButtons>
          <IonTitle>Cupom</IonTitle>

        </IonToolbar>


      </IonHeader>

      <IonContent fullscreen={false} className="Cupom-page">

        <div className="Cupom-manual-card">
          <div className="Cupom-manual-title">Tem um código de cupom?</div>
          <div className="Cupom-manual-row">
            <IonInput
              className="Cupom-manual-input"
              value={cupomManual}
              placeholder="Digite o cupom"
              onIonChange={(e: any) => setCupomManual(e.detail.value || "")}
            />
            <IonButton
              className="Cupom-manual-button"
              onClick={aplicarCupomManual}
            >
              Aplicar
            </IonButton>
          </div>
        </div>

        {loadConfiguracoesCupom()}


        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />
      </IonContent>

      <IonFooter>
        {(props.cupom) && (

          <IonToolbar style={{ padding: '10px' }}>


            <IonButton
              // color="success"
              style={{ height: "46px", fontSize: "18px" }}
              onClick={async () => {
                props.closeAction();
              }}
              expand="block"
              type="submit"
            >
              Remover Cupom
            </IonButton>


          </IonToolbar>

        )}
      </IonFooter>
    </>


  );
};

export default ({ configuracoesCupom, cupom, closeAction, closeActionSimple }: { configuracoesCupom: any[], cupom: any, closeAction: Function, closeActionSimple: Function }) => (
  <Cupom configuracoesCupom={configuracoesCupom} cupom={cupom} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </Cupom>
)
